import { Model } from "@vuex-orm/core";

export interface projectTypeEntity {
  id: string;
  serviceProviderId: number;
  createdById: number;
  createdOn: string;
  updatedById: number | null;
  updatedOn: string | null;
  name: string;
  description: string;
  isActive: boolean;
}

export class projectTypeEntity extends Model {
  static entity = "projectTypeEntity";
  static primaryKey = "id";

  static fields() {
    return {
      id: this.string(""),
      serviceProviderId: this.number(0),
      createdById: this.number(0),
      createdOn: this.attr(""),
      updatedById: this.number(null).nullable(),
      updatedOn: this.attr(null).nullable(),
      name: this.string(""),
      description: this.string(""),
      isActive: this.boolean(true),
    };
  }
}
